import { render, staticRenderFns } from "./UploadSimpleId.vue?vue&type=template&id=9e89faee&scoped=true&"
import script from "./UploadSimpleId.vue?vue&type=script&lang=js&"
export * from "./UploadSimpleId.vue?vue&type=script&lang=js&"
import style0 from "./UploadSimpleId.vue?vue&type=style&index=0&id=9e89faee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e89faee",
  null
  
)

export default component.exports